@if (isReady) {
  <ix-dropdown-button
    (click)="$event.stopPropagation()"
    [id]="dropdownId"
    class="full-button"
    icon="context-menu"
    onkeypress=""
    variant="tertiary">
    <ix-dropdown-item
      (click)="onShowQrClick()"
      icon="qr-code"
      onkeypress="">
      {{ 'battery_pass.list.show_qr_code' | translate }}
    </ix-dropdown-item>
    @if (isMasterPassport()) {
      <ix-dropdown-item
        (click)="onAddIndividualPassportClick()"
        icon="plus"
        onkeypress="">
        {{ 'battery_pass.list.create_children' | translate }}
      </ix-dropdown-item>
    }
    @if (isDataManager) {
      <ix-dropdown-item
        [routerLink]="['/app/edit-passport/', passportData.id]"
        icon="pen">
        {{ 'battery_pass.list.edit_passport' | translate }}
      </ix-dropdown-item>
      <ix-dropdown-item
        (click)="onRemovePassportClick()"
        icon="trashcan"
        onkeypress="">
        {{ 'battery_pass.list.remove_passport' | translate }}
      </ix-dropdown-item>
    }
  </ix-dropdown-button>
}
